import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import PropertyDetails from "../../components/RoomListView/PropertyDetails";
import OwnerRecDetails from "../../components/RoomListView/OwnerRecDetails";
import UserDetails from "../../components/RoomListView/UserDetails";
import BookingDetails from "../../components/RoomListView/BookingDetails";
import PriceDetails from "../../components/RoomListView/PriceDetails";
import TransactionDetails from "../../components/RoomListView/TransactionDetails";
import CouponAmount from "../../components/RoomListView/CouponAmount";
import PriceOwnerAdmin from "../../components/RoomListView/PriceOwnerAdmin";
import { useLocation } from "react-router-dom";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { VowAmount } from "../../components/RoomListView/VowAmount";
import PriceDetailsOwnerAdmin from "../../components/RoomListView/PriceDetailsOwnerAdmin";
import WalletAndCoupon from "../../components/RoomListView/WalletAndCoupon";
import OwnerCancelDetails from "../../components/RoomListView/OwnerCancelDetails";
import InvoiceDetails from "../../components/RoomListView/InvoiceDetails";

const BookingListView = ({ user_id }) => {
  const { state } = useLocation();
  const booking_id = state?.booking_id;
  const [details, setDetails] = useState({});

  useEffect(() => {
    viewDetails();
  }, []);

  const viewDetails = async () => {
    const res = await post(URLS.BOOKED_PROPERTY_DETAILS, {
      user_booking_id: booking_id,
    });
    console.log("property details view", res);
    if (res?.status === "success") {
      setDetails(res?.data);
    }
  };
  console.log("details", details);
  return (
    <div>
      {!user_id && (
        <Topbar header={"Booking List View"} subHead={"Bookings"} back={true} />
      )}
      <div className="d-flex flex-wrap gap-3 mt-4">
        <PropertyDetails PropertyDetails={details?.property_details} />

        <OwnerRecDetails ownerDetails={details?.owner_receptionist_details} />
        <UserDetails
          userDetails={details?.user_details}
          roomDetails={details?.room_details}
        />

        <BookingDetails data={details?.booking_details} />
        {/*  */}
        <PriceDetails data={details?.pricing_details?.room_wise_details} />
        <TransactionDetails data={details?.transaction_details} />
        {/* <CouponAmount
          data={details?.pricing_details?.price_summary}
          specialDate={details?.booking_details?.special_price}
        /> */}
        <PriceOwnerAdmin
          PriceDetails={{
            ...details?.price_for_owner_and_admin,
            ...details?.owner_breakdown,
            is_cancellation_booking: details?.is_cancellation_booking,
          }}
        />
        {details?.is_cancellation_booking && (
          <OwnerCancelDetails
            PriceDetails={{
              ...details?.price_for_owner_and_admin,
              ...details?.owner_breakdown,
              is_cancellation_booking: details?.is_cancellation_booking,
            }}
          />
        )}
        {/* <PriceDetailsOwnerAdmin
          PriceDetails={{
            ...details?.price_for_owner_and_admin,
            ...details?.owner_breakdown,
            is_cancellation_booking: details?.is_cancellation_booking,
          }}
        /> */}

        <div className="col-12 my-3">
          <h2 className=" f4 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 ">
            VOW Amount{" "}
            <span className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              (
              {details?.vow_breakdown?.property_owner_balance
                ? "Full"
                : "Advance"}{" "}
              Payment)
            </span>
            {details?.is_cancellation_booking && (
              <p className="ms-2 f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 red">
                Cancelled
              </p>
            )}
          </h2>
        </div>

        <VowAmount
          data={{
            ...details?.payment_details,
            isAdv: !details?.vow_breakdown?.property_owner_balance,
          }}
        />
        {details?.invoice_details?.status !== false && (
          <InvoiceDetails data={details?.invoice_details} />
        )}
        {/* <WalletAndCoupon
          data={{
            ...details?.vow_breakdown,
            isAdv: !details?.vow_breakdown?.property_owner_balance,
          }}
        /> */}
      </div>
      {/* <div className="d-flex flex-wrap gap-3 mt-4">
        <PropertyDetails PropertyDetails={details?.property_details} />
        <OwnerRecDetails ownerDetails={details?.owner_receptionist_details} />
        <UserDetails
          userDetails={details?.user_details}
          roomDetails={details?.room_details}
        />
        <BookingDetails data={details?.booking_details} />
        <PriceDetails data={details?.pricing_details?.room_wise_details} />
        <TransactionDetails data={details?.transaction_details} />
        <CouponAmount
          data={details?.pricing_details?.price_summary}
          specialDate={details?.booking_details?.special_price}
        />
        <PriceOwnerAdmin
          PriceDetails={{
            ...details?.price_for_owner_and_admin,
            ...details?.owner_breakdown,
            is_cancellation_booking: details?.is_cancellation_booking,
          }}
        />
        {details?.is_cancellation_booking && (
          <OwnerCancelDetails
            PriceDetails={{
              ...details?.price_for_owner_and_admin,
              ...details?.owner_breakdown,
              is_cancellation_booking: details?.is_cancellation_booking,
            }}
          />
        )}
        <PriceDetailsOwnerAdmin
          PriceDetails={{
            ...details?.price_for_owner_and_admin,
            ...details?.owner_breakdown,
            is_cancellation_booking: details?.is_cancellation_booking,
          }}
        />

        <div className="col-12 my-3">
          <h2 className=" f4 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 ">
            VOW Amount{" "}
            <span className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              (
              {details?.vow_breakdown?.property_owner_balance
                ? "Full"
                : "Advance"}{" "}
              Payment)
            </span>
            {details?.is_cancellation_booking && (
              <p className="ms-2 f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 red">
                Cancelled
              </p>
            )}
          </h2>
        </div>

        <VowAmount
          data={{
            ...details?.vow_breakdown,
            isAdv: !details?.vow_breakdown?.property_owner_balance,
          }}
        />
        <WalletAndCoupon
          data={{
            ...details?.vow_breakdown,
            isAdv: !details?.vow_breakdown?.property_owner_balance,
          }}
        />
      </div> */}
    </div>
  );
};
export default BookingListView;
